import Discovery from "./Discovery";

export default Discovery;
